<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

<!--    회의구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 회의구분
        </h5>
      </vs-col>
    </vs-row>
        <!-- Desktop 라디오 버튼 -->
    <div class="desktop-layout">
      <div class="mt-4" v-if="!isPrint">
        <label class="radio-option mr-4">
          <input
            type="radio"
            v-model="form.checkType"
            value="최초"
            :disabled="board.readonly"
            class="radio-input"
          />
          <span class="radio-label">최초</span>
        </label>
        <label class="radio-option mr-4">
          <input
            type="radio"
            v-model="form.checkType"
            value="정기"
            :disabled="board.readonly"
            class="radio-input"
          />
          <span class="radio-label">정기</span>
        </label>
        <label class="radio-option mr-4">
          <input
            type="radio"
            v-model="form.checkType"
            value="수시"
            :disabled="board.readonly"
            class="radio-input"
          />
          <span class="radio-label">수시</span>
        </label>
      </div>
      <div class="mt-4" v-if="isPrint">
        <p class="print-radio-value">{{ form.checkType }}</p>
      </div>
    </div>

        <!-- Mobile 라디오 버튼 -->
    <div class="mobile-layout">
      <div class="mobile-field mt-4">
        <div class="mobile-radio-group" v-if="!isPrint">
          <label class="mobile-radio-option">
            <input
              type="radio"
              v-model="form.checkType"
              value="최초"
              :disabled="board.readonly"
              class="mobile-radio-input"
            />
            <span class="mobile-radio-label">최초</span>
          </label>
          <label class="mobile-radio-option">
            <input
              type="radio"
              v-model="form.checkType"
              value="정기"
              :disabled="board.readonly"
              class="mobile-radio-input"
            />
            <span class="mobile-radio-label">정기</span>
          </label>
          <label class="mobile-radio-option">
            <input
              type="radio"
              v-model="form.checkType"
              value="수시"
              :disabled="board.readonly"
              class="mobile-radio-input"
            />
            <span class="mobile-radio-label">수시</span>
          </label>
        </div>
        <p v-if="isPrint" class="mobile-print-value">{{ form.checkType }}</p>
      </div>
    </div>

    <!--    협의체 정보-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 협의체 정보</h5>
      </vs-col>
    </vs-row>
    <!-- Desktop 레이아웃 -->
    <div class="desktop-layout">
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">평가차수</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">평가기간</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputB_2 }} ~ {{ form.inputB_3 }}
          </p>
          <div
            v-else
            class="w-full flex-1"
            style="display: flex; align-items: center"
          >
            <date-selector
              v-model="form.inputB_2"
              :readonly="board.readonly"
              @change="checkDate(form.inputB_2)"
            />
            &nbsp;~&nbsp;
            <date-selector
              v-model="form.inputB_3"
              :readonly="board.readonly"
              @change="checkDate(form.inputB_3)"
            />
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회의일</div>
          <p v-if="isPrint" class="print-input flex-1">
            {{ form.inputB_4 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full"
              v-model="form.inputB_4"
              :readonly="board.readonly"
            />
          </div>
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회의장소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_5 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_5"
            class="w-full flex-1"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">참석인원</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_6 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_6"
            class="w-full flex-1"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">참석업체</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_7 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_7"
            class="w-full flex-1"
            :readonly="board.readonly"
          />
        </div>
      </div>
    </div>

    <!-- Mobile 레이아웃 -->
    <div class="mobile-layout">
      <div class="mobile-form-container mt-4">
        <!-- 평가차수 -->
        <div class="mobile-field">
          <label class="mobile-field-label">평가차수</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">{{ form.inputB_1 }}</p>
            <ml-input
              v-else
              v-model="form.inputB_1"
              class="w-full"
              :readonly="true"
            />
          </div>
        </div>

        <!-- 평가기간 -->
        <div class="mobile-field">
          <label class="mobile-field-label">평가기간</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">
              {{ form.inputB_2 }} ~ {{ form.inputB_3 }}
            </p>
            <div
              v-else
              class="mobile-date-range"
            >
              <date-selector
                v-model="form.inputB_2"
                :readonly="board.readonly"
                @change="checkDate(form.inputB_2)"
                class="mobile-date-input"
              />
              <span class="date-separator">~</span>
              <date-selector
                v-model="form.inputB_3"
                :readonly="board.readonly"
                @change="checkDate(form.inputB_3)"
                class="mobile-date-input"
              />
            </div>
          </div>
        </div>

        <!-- 회의일 -->
        <div class="mobile-field">
          <label class="mobile-field-label">회의일</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">{{ form.inputB_4 }}</p>
            <date-selector
              v-else
              class="w-full"
              v-model="form.inputB_4"
              :readonly="board.readonly"
            />
          </div>
        </div>

        <!-- 회의장소 -->
        <div class="mobile-field">
          <label class="mobile-field-label">회의장소</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">{{ form.inputB_5 }}</p>
            <ml-input
              v-else
              v-model="form.inputB_5"
              class="w-full"
              :readonly="board.readonly"
            />
          </div>
        </div>

        <!-- 참석인원 -->
        <div class="mobile-field">
          <label class="mobile-field-label">참석인원</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">{{ form.inputB_6 }}</p>
            <ml-input
              v-else
              v-model="form.inputB_6"
              class="w-full"
              :readonly="board.readonly"
            />
          </div>
        </div>

        <!-- 참석업체 -->
        <div class="mobile-field">
          <label class="mobile-field-label">참석업체</label>
          <div class="mobile-field-input">
            <p v-if="isPrint" class="mobile-print-value">{{ form.inputB_7 }}</p>
            <ml-input
              v-else
              v-model="form.inputB_7"
              class="w-full"
              :readonly="board.readonly"
            />
          </div>
        </div>
      </div>
    </div>

<!--    주요 위험요인-->
    <table-risk-factor
      class="mt-5"
      :list="form.riskList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"/>

<!--    협의내용-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 협의내용</h5>
      </vs-col>
    </vs-row>
    <div class="print-container col-span-12 flex items-start mt-4">
      <div class="label-text mr-4 mt-2">협럭업체 건의사항<br/>(근로자 의견)</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_1 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_1"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">전달사항<br/>(경영자 의견)</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_2 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_2"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <!--    이전 회차 FEED BACK-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 이전 회차 FEED BACK</h5>
      </vs-col>
    </vs-row>
    <div class="print-container col-span-12 flex items-start mt-4">
      <div class="label-text mr-4 mt-2">양호사항<br/>(전회 우수사례)</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_1 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_1"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">불량사항<br/>(전회 미결사항)</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_2 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_2"
        class="flex-1 w-full"
        rows="5"
      />
    </div>
    <div class="print-container col-span-12 flex items-start">
      <div class="label-text mr-4 mt-2">추가 위험요인</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_3 }}</p>
      <ml-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputD_3"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import TableRiskFactor from '@/components/TableRiskFactor'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    TableRiskFactor,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    checkDate(input) {
      if (Date.parse(this.form.inputB_2) > Date.parse(this.form.inputB_3)) {
        if (input === this.form.inputB_2) {
          this.form.inputB_3 = this.form.inputB_2;
        } else {
          this.form.inputB_2 = this.form.inputB_3;
        }
      }
    },
    updateList(list) {
      this.form.riskList = list;
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        checkType: '최초',

        inputB_1: "최초",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        inputC_1: "",
        inputC_2: "",
        inputD_1: "",
        inputD_2: "",
        inputD_3: "",

        riskList: [],
        photoList: [],
        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
$mobile-breakpoint: 768px;

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

/* 반응형 레이아웃 제어 */
.desktop-layout {
  display: block;
}
.mobile-layout {
  display: none;
}

@media (max-width: $mobile-breakpoint) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .desktop-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}

/* Mobile 스타일 */
.mobile-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.mobile-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-field-label {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
}

.mobile-field-input {
  .vs-input,
  .vs-select,
  .date-selector {
    min-height: 44px; // 터치 친화적 크기

    .vs-input__input,
    .vs-select__input {
      font-size: 16px; // iOS 줌 방지
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #d1d5db;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }
}

.mobile-print-value {
  display: block;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  min-height: 20px;
}

.mobile-date-range {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  .mobile-date-input {
    flex: 1;
    min-width: 120px;
  }

  .date-separator {
    font-size: 16px;
    font-weight: 500;
    color: #6b7280;
    flex-shrink: 0;
  }
}

/* 작은 모바일 화면 최적화 */
@media (max-width: 480px) {
  .mobile-form-container {
    gap: 16px;
  }

  .mobile-field {
    gap: 6px;
  }

  .mobile-field-label {
    font-size: 13px;
  }

  .mobile-date-range {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    .mobile-date-input {
      flex: none;
      min-width: auto;
    }

    .date-separator {
      text-align: center;
      font-size: 14px;
    }
  }

  .mobile-field-input {
    .vs-input,
    .vs-select,
    .date-selector {
      min-height: 42px;

      .vs-input__input,
      .vs-select__input {
        font-size: 15px;
        padding: 10px 14px;
      }
    }
  }
}

/* 라디오 버튼 스타일 */
.print-radio-value {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  padding: 8px 0;
}

/* Desktop 라디오 버튼 */
.radio-option {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  .radio-input {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    cursor: pointer;
    accent-color: #3b82f6;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .radio-label {
    font-size: 16px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: color 0.2s ease;
  }

  &:hover:not(:has(.radio-input:disabled)) {
    .radio-label {
      color: #3b82f6;
    }
  }

  &:has(.radio-input:disabled) {
    cursor: not-allowed;
    opacity: 0.6;

    .radio-label {
      cursor: not-allowed;
    }
  }
}

/* Mobile 라디오 버튼 */
.mobile-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .mobile-radio-option {
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    user-select: none;

    .mobile-radio-input {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      cursor: pointer;
      accent-color: #3b82f6;
      transform: scale(1.2);

      &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
      }
    }

    .mobile-radio-label {
      font-size: 16px;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      flex: 1;
      transition: color 0.2s ease;
    }

    &:hover:not(:has(.mobile-radio-input:disabled)) {
      .mobile-radio-label {
        color: #3b82f6;
      }
    }

    &:has(.mobile-radio-input:disabled) {
      cursor: not-allowed;
      opacity: 0.6;

      .mobile-radio-label {
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 480px) {
  .mobile-radio-group {
    gap: 10px;

    .mobile-radio-option {
      min-height: 40px;

      .mobile-radio-input {
        width: 18px;
        height: 18px;
        transform: scale(1.1);
      }

      .mobile-radio-label {
        font-size: 15px;
      }
    }
  }
}
</style>
